export default __webpack_public_path__ + "static/media/100.36bb2b44.png";